<div class="section over-hide">
    <div class="section padding-top-120 section-background-rana rana-shell-flush">
        <div class="section-1400 rana-full-bleed">
            <div class="container-fluid px-0">

                <div class="row no-gutters rana-shell" id="matrimonialAccordion">

                    <!-- LEFT FIXED MENU -->
                    <div class="col-lg-4 rana-shell-rail">
                        <div class="section border-4 p-3 p-xl-4 rana-mat-rail">

                            <div class="rana-mat-brand">
                                <div class="rana-mat-brand-mark">
                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>
                                </div>
                                <div>
                                    <div class="rana-mat-brand-title">RANA</div>
                                    <div class="rana-mat-brand-subtitle">Matrimonial</div>
                                </div>
                            </div>

                            <div class="d-lg-none">
                                <button type="button" class="rana-nav-mobile-toggle" data-toggle="collapse"
                                        data-target="#matrimonialNavRailLinks" aria-expanded="false"
                                        aria-controls="matrimonialNavRailLinks">
                                    <span>Menu</span>
                                    <i class="uil uil-angle-down size-20"></i>
                                </button>
                            </div>

                            <div class="collapse d-lg-block" id="matrimonialNavRailLinks">
                                <div class="rana-mat-nav-group-label">Directory</div>

                                <button type="button" class="rana-mat-nav-link" [class.active]="mode==='approved'"
                                        (click)="mode='approved'">
                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 2 8l10 5 10-5-10-5z"/><path d="m2 13 10 5 10-5"/></svg>
                                    Matrimonial Listings
                                </button>

                                <button type="button" class="rana-mat-nav-link" [class.active]="mode==='pending'"
                                        *ngIf="userRole?.MATRIMONIAL?.includes('APPROVE')"
                                        (click)="mode='pending'">
                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
                                    Show Pending Profiles
                                </button>
                            </div>

                            <div class="rana-mat-rail-spacer"></div>

                            <p class="rana-mat-rail-note">Every profile is reviewed by the NEC before it goes live.</p>
                        </div>
                    </div>

                    <!-- CONTENT AREA -->
                    <div class="col-lg-8 mt-4 mt-lg-0 rana-shell-main">
                        <div class="section border-4 p-3 p-xl-4 rana-shell-main-inner" #parentSection>

                            <!-- Single Matrimonial Component -->
                            <app-matrimonial [mode]="mode"
                                             (profileViewModeChange)="onProfileModeChange($event)"></app-matrimonial>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
